<template>
	<b-row :class="(is_deleted ? 'archived-section' : '')" >
		<b-col cols="12">
			<DisbursementSummary />
				<!-- <el-collapse v-model="activeNames">
				<el-collapse-item title="Disbursement Details" name="1" disabled>
					<template slot="title">
						<div class="p-2 d-flex justify-content-between align-items-center w-100">
							<h4 class="mb-0">Disbursement Details</h4>
							<el-button type="primary" plain size="small">
								+ Add Disbursement
							</el-button>
						</div>
					</template>
				</el-collapse-item>
			</el-collapse> -->
			<DisbursementDetail/>
		</b-col>
	</b-row>
</template>

<script>
import { Button, Collapse, CollapseItem } from 'element-ui'
import DisbursementSummary from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Disbursement/DisbursementSummary'
import DisbursementDetail from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Disbursement/DisbursementDetail'
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export default {
	components: {
		DisbursementSummary,
		DisbursementDetail,
		[Button.name]: Button,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
	},
	data() {
		return {
			activeNames: ['1']
		};
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase']),
		is_deleted(){
			return !_gHlp.isEmpty(this.activeCase.deleted_at);
		}
  },
	methods: {
		handleChange(val) {
		}
	}
}
</script>